/**
 * Target IDs for this takeover. This is the only file that owns IDs.
 * Import populated collections from manifest.ts; never from <id>.tsx.
 */
export const shpIds = [
  '8f9b0ea9-2070-4268-99c0-b94d6f24d0e0',
  '54708d4d-b56a-4585-86b4-7a32095fa8bf', // CA - Simple Home Page
] as const;

/** Menu section IDs grouped by section config. */
export const menuSectionIds = {
  meals: [
    '81c30888-929e-4103-ac04-6f1089417b78', // Dragon Ball Super
    '59df43b6-96c7-41a9-8ac5-a49a92d9a159', // CA - Dragon Ball Super Section
  ],
  kids: [
    'section_5603',
    'e16a5fec-06a5-4346-89f1-0ca2dc07b203', // CA - King Jr.® Kids Meals - Menu
  ],
};

/** PDP/cart item IDs grouped by cart treatment. */
export const pdpItemIds = {
  meal: [
    '15441de8-68f0-4081-85b1-0dd1126dd6eb', // Power Up Pack
    'd8942ac4-46c8-4119-9909-ca95597ef27c', // 10pc Chicken Nuggets with Super Saiyan Sauce combo slot
    'item_105531', // 10pc Chicken Nuggets with Super Saiyan Sauce item
    'c2bc71af-f200-46ea-8b88-16f9a4098c36', // Select Your Medium Side - Power Up Pack combo slot
    '185bb9ac-cc09-4897-94a6-1f5c0107e0d8', // Select Your Medium Lemonade combo slot
    'ddf81d35-236b-4f4a-ae07-17648ab41297', // Jr Combo Treats - Power Up Bundle combo slot
    'item_106910', // Toy
    'b77de603-c758-427a-8b7b-109a7dde9c31', // Power Up Pack without toy fallback
    '41f4cac5-fc56-4e73-ad2c-64411b2594f2', // Dragon Ball Burst Lemonade picker
    'item_103799', // Kids Dragon Ball Burst Lemonade
    'item_103800', // Small Dragon Ball Burst Lemonade
    'item_103801', // Medium Dragon Ball Burst Lemonade
    'item_103802', // Large Dragon Ball Burst Lemonade
    'item_105995', // CA - Dragon Ball Burst Lemonade
    'item_105996', // CA - Strawberry Lemonade with Mango Boba
    '3305cf6c-2b9b-4f0e-a22c-5252a40d9144', // CA - 8 Pc. Chicken Nuggets with Super Saiyan Sauce
    'item_93505', // CA - 8 Pc. Chicken Nuggets #2
    'c0ef5aa4-4a3c-490e-bf8f-a5f89bebe5fd', // CA - 8 Pc. Chicken Nuggets with Saiyan Sauce Medium Combo
    '0e859e90-ae99-42ab-87fd-126e1f734971', // CA - 8 Pc. Chicken Nuggets with Saiyan Sauce Large Combo
    '073edbaf-65c7-42e6-ac06-0256a92d6212', // CA - Power Up Pack
    '9a1b72c7-f8a4-4115-a5fd-f666a5cdfa5f', // CA - 8 Pc. Chicken Nuggets with Super Saiyan Sauce (Power Up Pack)
    'e2f0fa27-ede6-4123-b052-37e6d7e075b8', // CA - Medium Combo Sides - Dragon Ball
    '2eb2f186-4ec5-4548-a8e4-4d0aaf611e06', // CA - Dragon Ball Burst Lemonade (Power Up Pack)
    'e183a4f2-a6dc-4276-b371-d4e367ea5679', // CA - Power Up Pack (No Toy)
    'item_105993', // CA - Super Saiyan Sauce
  ],
  kids: [
    'c7225019-9e47-43c4-8e97-8a6c4224a84a', // Cheeseburger King Jr. Meal (PAR)
    'f2ad9d67-6e2f-43b0-a259-44a3669dd4db', // Hamburger King Jr. Meal (PAR)
    'f7d1ba8f-4a71-4b63-87f8-5afe0c9e0c18', // 4 Pc. Chicken Nuggets King Jr. Meal (Elevated)
    '05165624-29df-46d3-8f3c-fd262dcc73fe', // 6 Pc. Chicken Nuggets King Jr. Meal (Elevated)
    'combo_5796', // Cheeseburger King Jr. Meal
    'combo_5774', // Hamburger King Jr. Meal
    'afdd6640-7af3-4dc3-a373-bb73905a4982', // Cheeseburger King Jr. Meal (NCR)
    '5632e94a-f24c-4c20-b6d8-33d711fbd2a4', // 4 Pc. Chicken Nuggets King Jr. Meal (NCR, Elevated)
    '5b8a9798-ee72-4609-905d-5665ad0d5f7e', // 6 Pc. Chicken Nuggets King Jr. Meal (NCR, Elevated)
    '258be439-eb43-4c31-91a9-96ad243b38df', // Hamburger King Jr. Meal (NCR)
    'beceeb00-8c99-42bb-a039-40ee92392a05', // CA - 3 Pc. French Toast Sticks King Jr.® Meal
    '909c1fae-8d77-403a-9e5e-5c23f3715f4f', // CA - Cheeseburger King Jr.® Meal
    '381f1583-5318-4915-9042-0dcc76ab3dd6', // CA - Hamburger King Jr.® Meal
    'f17760cf-4ca2-4055-9a7b-e5f647a5dbe1', // CA - 4 Pc. Chicken Nuggets King Jr.® Meal
  ],
} as const;
